import { User } from '../models/user'
export interface UserStateType {
  users: User[]
  user: User | null
}

const UserState: () => UserStateType = () => ({
  users: [],
  user: null,
})

export default UserState
